module.exports = "/images/vendor/flag-icon-css/flags/1x1/td.svg?f37a395c81f2cfe3b51e5f254970b8b7";